"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fuse_js_1 = tslib_1.__importDefault(require("fuse.js"));
exports.searchContentItems = (searchQuery, items) => {
    return new fuse_js_1.default(items, {
        caseSensitive: false,
        includeMatches: true,
        includeScore: true,
        keys: [
            {
                name: 'title.data',
                weight: 0.75,
            },
            {
                name: 'content.data',
                weight: 0.25,
            },
        ],
        shouldSort: true,
        tokenize: true,
    }).search(searchQuery);
};
//# sourceMappingURL=searchContentItems.js.map